/* Wholesale order builder — filters, steppers, tier pricing, sticky bar, cart. */
(function () {
  'use strict';
  function boot() {
  if (window.__wsBooted) return;            // the script tag may appear in more than one section
  var dataEl = document.getElementById('ws-data');
  if (!dataEl) return;
  window.__wsBooted = true;
  var root = document;                       // sections live anywhere on the page

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[wholesale] bad data', e); return; }

  var copy = data.copy || {};
  var tiers = data.tiers || [];
  var account = data.account || 'guest';
  // sticky-bar copy lives on that section's root
  var stickySec = document.querySelector('[data-ws-sticky-section]');
  if (stickySec) {
    var ds = stickySec.dataset;
    copy.msg_min = ds.msgMin; copy.msg_98 = ds.msgT2; copy.msg_300 = ds.msgT3; copy.msg_max = ds.msgMax;
    copy.spool_count = ds.count; copy.cta_need = ds.ctaNeed; copy.cta_adding = ds.ctaAdding; copy.err_summary = ds.errSummary;
  }
  var ALL = '__all__';
  var STORE_KEY = 'ws-order-v1';

  // ---------- data ----------
  var products = (data.products || []).filter(function (p) { return p.variants && p.variants.length; });
  var byId = {};
  products.forEach(function (p) {
    p.variants.forEach(function (v) {
      v.qty = 0;
      v.soldOut = !v.available || v.max <= 0;
      v.product = p;
      byId[v.id] = v;
    });
    var inStock = p.variants.filter(function (v) { return !v.soldOut; });
    var pool = inStock.length ? inStock : p.variants;
    p.minPrice = Math.min.apply(null, pool.map(function (v) { return v.price; }));
    p.count = p.variants.length;
  });
  var totalColours = products.reduce(function (n, p) { return n + p.count; }, 0);

  // restore an in-progress order from this tab
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    Object.keys(saved).forEach(function (id) {
      var v = byId[id];
      if (v && !v.soldOut) v.qty = clamp(parseInt(saved[id], 10) || 0, 0, v.max);
    });
  } catch (e) {}

  var state = { selected: null, tier: 0 };
  (function () {
    var def = products.filter(function (p) { return p.handle === data.default_handle; })[0];
    if (!def) def = products.filter(function (p) { return /^PLA\+/i.test(p.title); })[0];
    state.selected = def ? def.handle : (products[0] ? products[0].handle : ALL);
  })();

  // ---------- helpers ----------
  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
  function money(cents) { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tpl(s, vars) {
    var v = { t1: tiers[0] && tiers[0].min, t2: tiers[1] && tiers[1].min, t3: tiers[2] && tiers[2].min };
    for (var k in vars) v[k] = vars[k];
    return String(s || '').replace(/\{(\w+)\}/g, function (_, key) { return v[key] != null ? v[key] : ''; });
  }
  function totalQty() { return products.reduce(function (n, p) { return n + p.variants.reduce(function (m, v) { return m + v.qty; }, 0); }, 0); }
  function tierIndex(total) { return total >= tiers[2].min ? 2 : total >= tiers[1].min ? 1 : 0; }
  function tierPrice(cents, ti) { return Math.max(0, cents - tiers[ti].off); }
  function selectedProducts() { return state.selected === ALL ? products : products.filter(function (p) { return p.handle === state.selected; }); }
  function persist() {
    try {
      var o = {};
      products.forEach(function (p) { p.variants.forEach(function (v) { if (v.qty > 0) o[v.id] = v.qty; }); });
      sessionStorage.setItem(STORE_KEY, JSON.stringify(o));
    } catch (e) {}
  }

  var $pills = root.querySelector('[data-ws-pills]');
  var $tiers = root.querySelector('[data-ws-tiers]');
  var $caption = root.querySelector('[data-ws-caption]');
  var $grid = root.querySelector('[data-ws-grid]');
  var $table = root.querySelector('[data-ws-table] tbody');
  if (!$pills || !$tiers || !$grid) return;
  function $(sel) { return root.querySelector(sel); }
  function setText(sel, text) { var el = $(sel); if (el) el.textContent = text; }

  // ---------- render ----------
  function renderPills() {
    var html = '<button type="button" class="ws-pill' + (state.selected === ALL ? ' is-active' : '') + '" data-ws-pill="' + ALL + '" role="tab" aria-selected="' + (state.selected === ALL) + '">' + esc(copy.all || 'All') + ' <span>' + totalColours + '</span></button>';
    products.forEach(function (p) {
      var on = state.selected === p.handle;
      html += '<button type="button" class="ws-pill' + (on ? ' is-active' : '') + '" data-ws-pill="' + esc(p.handle) + '" role="tab" aria-selected="' + on + '">' + esc(p.title) + ' <span>' + p.count + '</span></button>';
    });
    $pills.innerHTML = html;
  }

  function renderTiers() {
    var ti = state.tier;
    var sel = selectedProducts();
    var basePrice = Math.min.apply(null, sel.map(function (p) { return p.minPrice; }));
    var isAll = state.selected === ALL;
    var fmt = function (n) { return Number(n).toLocaleString('en-US'); };
    var formTiers = copy.show_form_tiers === false ? [] : (data.form_tiers || []);
    var cards = tiers.map(function (t, i) { return { min: t.min, off: t.off, online: true, current: i === ti }; })
      .concat(formTiers.map(function (t) { return { min: t.min, off: t.off, online: false, current: false }; }));
    var html = '';
    cards.forEach(function (c) {
      var tag = c.online ? (c.current ? (copy.your_tier || 'Your tier') : (copy.order_online || 'Order online')) : (copy.order_form || 'Order form only');
      var cls = 'ws-tier' + (c.current ? ' is-current' : '') + (c.online ? '' : ' ws-tier--form');
      var inner =
        '<div class="ws-tier__label">' + fmt(c.min) + '+ ' + esc(copy.spools || 'spools') + '</div>' +
        '<div class="ws-tier__price">' + (isAll ? '<small>' + esc(copy.from || 'from') + '</small>' : '') + money(Math.max(0, basePrice - c.off)) + '</div>' +
        '<div class="ws-tier__per">' + esc(isAll ? '' : sel[0].title) + ' ' + esc(copy.per_spool || '/ spool') + '</div>' +
        '<span class="ws-tier__tag">' + esc(tag) + '</span>';
      html += (!c.online && copy.form_url)
        ? '<a class="' + cls + '" href="' + esc(copy.form_url) + '">' + inner + '</a>'
        : '<div class="' + cls + '">' + inner + '</div>';
    });
    $tiers.style.setProperty('--ws-tier-cols', cards.length);
    $tiers.innerHTML = html;
  }

  function renderCaption() {
    if (!$caption) return;
    var n = selectedProducts().reduce(function (k, p) { return k + p.count; }, 0);
    $caption.textContent = tpl(copy.caption, { n: n, m: totalColours });
  }

  function cardHtml(p, v) {
    return '<div class="ws-card' + (v.soldOut ? ' is-soldout' : '') + (v.qty > 0 ? ' has-qty' : '') + (v.error ? ' has-error' : '') + '" data-ws-card="' + v.id + '">' +
      '<div class="ws-card__img">' + (v.image ? '<img src="' + esc(v.image) + '" alt="' + esc(p.title + ' ' + v.colour) + '" loading="lazy" width="400" height="400">' : '') + '</div>' +
      '<div class="ws-card__body">' +
        '<div class="ws-card__title">' + esc(p.title) + '</div>' +
        '<div class="ws-card__colour">' + esc(v.colour) + ' ' + esc(copy.kg || '/ 1 kg') + '</div>' +
        '<div class="ws-card__price"><span data-ws-price>' + money(tierPrice(v.price, state.tier)) + '</span><s>' + money(v.price) + '</s></div>' +
        (v.soldOut
          ? '<div class="ws-card__soldout">' + esc(copy.sold_out || 'Sold out') + '</div>'
          : '<div class="ws-stepper">' +
              '<button type="button" data-ws-dec aria-label="Decrease"' + (v.qty <= 0 ? ' disabled' : '') + '>&minus;</button>' +
              '<input type="number" inputmode="numeric" min="0" max="' + v.max + '" value="' + v.qty + '" data-ws-qty aria-label="Quantity">' +
              '<button type="button" data-ws-inc aria-label="Increase"' + (v.qty >= v.max ? ' disabled' : '') + '>+</button>' +
            '</div>') +
        '<div class="ws-card__err" data-ws-err' + (v.error ? '' : ' hidden') + '>' + esc(v.error || '') + '</div>' +
      '</div>' +
    '</div>';
  }

  function renderGrid() {
    var html = '';
    selectedProducts().forEach(function (p) { p.variants.forEach(function (v) { html += cardHtml(p, v); }); });
    $grid.innerHTML = html;
  }

  function renderTable() {
    if (!$table) return;
    var formTiers = data.form_tiers || [];
    var fmt = function (n) { return Number(n).toLocaleString('en-US'); };
    var tableEl = root.querySelector('[data-ws-table]');
    var colLabel = (tableEl && tableEl.getAttribute('data-ws-col-material')) || copy.col_material || 'Material';
    var head = '<tr><th>' + esc(colLabel) + '</th>';
    tiers.forEach(function (t) { head += '<th class="is-online">' + fmt(t.min) + '+</th>'; });
    formTiers.forEach(function (t) { head += '<th class="is-form">' + fmt(t.min) + '+</th>'; });
    head += '</tr>';
    var thead = root.querySelector('[data-ws-thead]');
    if (thead) thead.innerHTML = head;

    var html = '';
    products.forEach(function (p) {
      html += '<tr><td>' + esc(p.title) + '</td>';
      tiers.forEach(function (t) { html += '<td class="is-online">' + money(Math.max(0, p.minPrice - t.off)) + '</td>'; });
      formTiers.forEach(function (t) { html += '<td class="is-form">' + money(Math.max(0, p.minPrice - t.off)) + '</td>'; });
      html += '</tr>';
    });
    $table.innerHTML = html;
  }

  function buildRail() {
    var rail = $('[data-ws-rail]');
    if (!rail || rail.getAttribute('data-ws-rail-built')) return;
    rail.setAttribute('data-ws-rail-built', '1');
    var top = tiers[tiers.length - 1].min;
    var html = '<div class="ws-rail__fill" data-ws-rail-fill></div>';
    tiers.forEach(function (t) {
      html += '<span class="ws-rail__dot" style="left:' + (t.min / top * 100).toFixed(2) + '%" data-ws-dot="' + t.min + '"><i>' + t.min + '</i></span>';
    });
    rail.innerHTML = html;
  }

  // Keep the bar anchored to the viewport: a transformed theme wrapper would otherwise trap position:fixed.
  function portalSticky() {
    var el = $('[data-ws-sticky]');
    if (!el || (window.Shopify && window.Shopify.designMode) || el.parentNode === document.body) return;
    el.classList.add('ws');
    document.body.appendChild(el);
  }

  function renderSticky() {
    if (!$('[data-ws-sticky]')) return;
    portalSticky();
    buildRail();
    var total = totalQty();
    var ti = state.tier;
    var sum = products.reduce(function (n, p) { return n + p.variants.reduce(function (m, v) { return m + v.qty * tierPrice(v.price, ti); }, 0); }, 0);
    var msg;
    if (total < tiers[0].min) msg = tpl(copy.msg_min, { n: tiers[0].min - total });
    else if (total < tiers[1].min) msg = tpl(copy.msg_98, { n: tiers[1].min - total });
    else if (total < tiers[2].min) msg = tpl(copy.msg_300, { n: tiers[2].min - total });
    else msg = copy.msg_max || '';
    setText('[data-ws-msg]', msg);
    setText('[data-ws-total]', money(sum));
    setText('[data-ws-count]', tpl(copy.spool_count, { n: total }));
    var fill = $('[data-ws-rail-fill]');
    if (fill) fill.style.width = Math.min(100, total / tiers[2].min * 100) + '%';
    Array.prototype.forEach.call(root.querySelectorAll('[data-ws-dot]'), function (d) {
      d.classList.toggle('is-passed', total >= parseInt(d.getAttribute('data-ws-dot'), 10));
    });
    // approved accounts: checkout buttons unlock at the minimum
    if (account === 'approved') {
      var ok = total >= tiers[0].min;
      var add = $('[data-ws-add]'), buy = $('[data-ws-buy]'), hint = $('[data-ws-cta-hint]');
      if (add) add.disabled = !ok;
      if (buy) buy.disabled = !ok;
      if (hint) hint.textContent = ok ? '' : tpl(copy.cta_need, { n: tiers[0].min - total });
    }
  }

  // Update a single card in place (keeps the input focused while typing)
  function syncCard(v) {
    var card = $grid.querySelector('[data-ws-card="' + v.id + '"]');
    if (!card) return;
    card.classList.toggle('has-qty', v.qty > 0);
    var input = card.querySelector('[data-ws-qty]');
    if (input && document.activeElement !== input) input.value = v.qty;
    var dec = card.querySelector('[data-ws-dec]'), inc = card.querySelector('[data-ws-inc]');
    if (dec) dec.disabled = v.qty <= 0;
    if (inc) inc.disabled = v.qty >= v.max;
  }

  // Re-price every visible card when the tier changes
  function syncPrices() {
    Array.prototype.forEach.call($grid.querySelectorAll('[data-ws-card]'), function (card) {
      var v = byId[card.getAttribute('data-ws-card')];
      var el = card.querySelector('[data-ws-price]');
      if (v && el) el.textContent = money(tierPrice(v.price, state.tier));
    });
  }

  function afterQtyChange(v) {
    var prevTier = state.tier;
    state.tier = tierIndex(totalQty());
    syncCard(v);
    if (state.tier !== prevTier) { syncPrices(); renderTiers(); }
    renderSticky();
    persist();
  }

  function setQty(v, n) {
    if (v.soldOut) return;
    n = clamp(parseInt(n, 10) || 0, 0, v.max);
    if (n === v.qty) { syncCard(v); return; }
    v.qty = n;
    afterQtyChange(v);
  }

  function select(handle) {
    if (handle === state.selected) return;
    state.selected = handle;
    renderPills(); renderTiers(); renderCaption(); renderGrid();
  }

  // ---------- events ----------
  $pills.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ws-pill]');
    if (btn) select(btn.getAttribute('data-ws-pill'));
  });

  $grid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ws-inc],[data-ws-dec]');
    if (!btn) return;
    var card = btn.closest('[data-ws-card]');
    var v = byId[card.getAttribute('data-ws-card')];
    if (!v) return;
    setQty(v, v.qty + (btn.hasAttribute('data-ws-inc') ? 1 : -1));
  });

  $grid.addEventListener('input', function (e) {
    var input = e.target.closest('[data-ws-qty]');
    if (!input || input.value === '') return;
    var v = byId[input.closest('[data-ws-card]').getAttribute('data-ws-card')];
    if (v) setQty(v, input.value);
  });

  $grid.addEventListener('change', function (e) {
    var input = e.target.closest('[data-ws-qty]');
    if (!input) return;
    var v = byId[input.closest('[data-ws-card]').getAttribute('data-ws-card')];
    if (!v) return;
    setQty(v, input.value);
    input.value = v.qty; // normalise blanks / out-of-range on blur
  });

  $grid.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('[data-ws-qty]')) { e.preventDefault(); e.target.blur(); }
  });


  // ---------- cart (approved accounts only) ----------
  var $add = root.querySelector('[data-ws-add]');
  var $buy = root.querySelector('[data-ws-buy]');
  var $ctaErr = root.querySelector('[data-ws-cta-error]');
  var busy = false;

  function lines() {
    var out = [];
    products.forEach(function (p) { p.variants.forEach(function (v) { if (v.qty > 0) out.push({ id: v.id, quantity: v.qty }); }); });
    return out;
  }

  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (body) { return { ok: r.ok, status: r.status, body: body || {} }; });
    });
  }

  function errorText(body) { return (body && (body.description || body.message)) || copy.err_generic || 'Something went wrong.'; }

  function clearErrors() {
    products.forEach(function (p) { p.variants.forEach(function (v) { v.error = null; }); });
    Array.prototype.forEach.call($grid.querySelectorAll('.ws-card.has-error'), function (card) {
      card.classList.remove('has-error');
      var el = card.querySelector('[data-ws-err]'); if (el) { el.hidden = true; el.textContent = ''; }
    });
    if ($ctaErr) { $ctaErr.hidden = true; $ctaErr.textContent = ''; }
  }

  function showCardError(v, message) {
    v.error = message;
    var card = $grid.querySelector('[data-ws-card="' + v.id + '"]');
    if (!card) return;
    card.classList.add('has-error');
    var el = card.querySelector('[data-ws-err]'); if (el) { el.textContent = message; el.hidden = false; }
  }

  function showSummaryError(message) { if ($ctaErr) { $ctaErr.textContent = message; $ctaErr.hidden = false; } }

  function setBusy(on, which) {
    busy = on;
    [$add, $buy].forEach(function (b) {
      if (!b) return;
      if (on) { b.setAttribute('data-ws-label', b.textContent); b.disabled = true; if (b === which) b.textContent = copy.cta_adding || 'Adding…'; }
      else { var l = b.getAttribute('data-ws-label'); if (l) b.textContent = l; b.removeAttribute('data-ws-label'); }
    });
    if (!on) renderSticky(); // restores enabled state from the current total
  }

  // Theme cart drawer: refresh + open. Falls back to the cart page.
  function openDrawer() {
    try {
      if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') { window.Shopify.onCartUpdate(undefined, true); return; }
      var C = window.MinimogTheme && window.MinimogTheme.Cart;
      if (C && C.refreshCart && C.renderNewCart && C.openCartDrawer) {
        Promise.resolve(C.refreshCart()).then(function () { return C.renderNewCart(); }).then(function () { C.openCartDrawer(); });
        return;
      }
    } catch (e) { /* fall through */ }
    api.go('/cart');
  }

  // Batch add; on a 422 re-send one line at a time so the failing colour(s) can be pointed at.
  function addSelection(mode) {
    if (busy || account !== 'approved') return;
    var items = lines();
    if (!items.length || totalQty() < tiers[0].min) return;
    setBusy(true, mode === 'buy' ? $buy : $add);
    clearErrors();

    postAdd(items).then(function (res) {
      if (res.ok) return { added: items, failed: [] };
      if (res.status !== 422) throw new Error(errorText(res.body));
      return items.reduce(function (chain, line) {
        return chain.then(function (acc) {
          return postAdd([line]).then(function (r) {
            if (r.ok) acc.added.push(line); else acc.failed.push({ line: line, message: errorText(r.body) });
            return acc;
          });
        });
      }, Promise.resolve({ added: [], failed: [] }));
    }).then(function (result) {
      // what went into the cart leaves the builder; what failed stays, with the reason on its card
      result.added.forEach(function (l) { var v = byId[l.id]; if (v) { v.qty = 0; syncCard(v); } });
      result.failed.forEach(function (f) { var v = byId[f.line.id]; if (v) showCardError(v, f.message); });
      state.tier = tierIndex(totalQty());
      syncPrices(); renderTiers(); renderSticky(); persist();

      if (result.failed.length) {
        showSummaryError(tpl(copy.err_summary, { n: result.failed.length }));
        var first = byId[result.failed[0].line.id];
        if (first && state.selected !== ALL && state.selected !== first.product.handle) select(first.product.handle);
        var card = first && $grid.querySelector('[data-ws-card="' + first.id + '"]');
        if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (result.added.length) {
        if (mode === 'buy' && !result.failed.length) {
          try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
          api.go('/discount/' + encodeURIComponent(data.discount_code || '') + '?redirect=' + encodeURIComponent(copy.checkout_url || '/checkout'));
          return;
        }
        openDrawer();
      }
    }).catch(function (e) {
      showSummaryError(copy.err_generic || (e && e.message) || 'Something went wrong.');
    }).then(function () { setBusy(false); });
  }

  if ($add) $add.addEventListener('click', function () { addSelection('cart'); });
  if ($buy) $buy.addEventListener('click', function () { addSelection('buy'); });

  var api = { go: function (url) { window.location.href = url; } };

  // ---------- boot ----------
  state.tier = tierIndex(totalQty());
  renderPills(); renderTiers(); renderCaption(); renderGrid(); renderTable(); renderSticky();

  window.WholesaleBuilder = {
    products: products, state: state, byId: byId,
    totalQty: totalQty, tierPrice: tierPrice, lines: lines,
    add: function () { addSelection('cart'); }, buy: function () { addSelection('buy'); },
    api: api
  };
  }

  boot();
  // theme editor re-renders sections in place; rebuild against the fresh DOM
  document.addEventListener('shopify:section:load', function () { window.__wsBooted = false; boot(); });
})();
